import React from 'react';
import {
  Component,
  Position
} from 'puzzle';
import Create from "./Create/Create";
import Edit from "./Edit/Edit";
import Clone from "./Clone/Clone";
import TemplateCreate from "./TemplateCreate/TemplateCreate";
import TemplateEdit from "./TemplateEdit/TemplateEdit";
import _ from 'lodash';
import { setDocumentTitle } from "../util/Util";

type PROPS = {
  setFolderTitle: Function
}
type STATE = {
  mode: 'CREATE' | 'EDIT' | 'CLONE' | 'TEMPLATE_CREATE' | 'TEMPLATE_EDIT'
}
const defaultMode = 'CREATE';

class SubmissionCrossover extends Component<PROPS, STATE> {
  public state: STATE = {
    mode: defaultMode
  };

  /**
   * Since every redirecton to this module trough dispatcher also calls setMode method which sets mode to state
   * That state does not update before checkIfSubmissionModeMatchesUrl method, in moduleDidMount, called
   * So this variable duplicate of this.state.mode, also set in setMode method but in real time,
   * hence is referent and should be used in checkIfSubmissionModeMatchesUrl unlike this.state.mode
   */
  modeSet: string = defaultMode;

  /**
   * @inheritDoc
   */
  moduleDidMount = () => {
    setDocumentTitle(this.props.title);
    this.checkIfSubmissionModeMatchesUrl();
  };

  componentWillUnmount(): void {
    super.componentWillUnmount();
    this.props.setFolderTitle(defaultMode.toLowerCase());
  }

  componentDidUpdate(prevProps: PROPS, prevState: STATE) {
    if (prevState.mode !== this.state.mode) {
      setDocumentTitle(this.props.title);
    }
  }


  checkIfSubmissionModeMatchesUrl = () => {
    const { url, params } = this.props.match;
    const mode = this.modeSet;
    const pathSegments = url.split('/');
    pathSegments.shift();
    const submissionType = pathSegments[1];
    let match = false;
    if (_.isEmpty(params) && pathSegments.length === 2) {
      match =
        (submissionType === 'submission' && (mode === 'CREATE' || mode === 'CLONE')) ||
        (submissionType === 'template' && mode === "TEMPLATE_CREATE")
    } else if (params.id && pathSegments.length === 3) {
      match =
        (submissionType === 'submission' && mode === 'EDIT') ||
        (submissionType === 'template' && mode === "TEMPLATE_EDIT")
    }
    if (!match) this.dispatch('goToPath', Position.start, { path: '/view/dashboard' })

  };

  setMode = (mode: string) => {
    this.modeSet = mode;
    this.setState({ mode });
    this.props.setFolderTitle(mode.toLowerCase());
  };

  getMode = (): string => this.state.mode;

  /**
   * Returns user to previous page
   * Used on Cancel button on submission page
   */
  goBack = () => this.props.history?.goBack();

  /**
   * Return the current module name used for change route dialog
   */
  getModuleName = () => {
    let currentModuleName;
    if (_.includes(['CREATE', 'EDIT', 'CLONE'], this.state.mode)) {
      currentModuleName = _.capitalize(this.state.mode);
    } else {
      currentModuleName = this.state.mode === 'TEMPLATE_CREATE' ? 'TemplateCreate' : 'TemplateEdit';
    }
    return currentModuleName;
  }

  render() {
    let component;
    const { mode } = this.state;
    const { tptEnabled } = this.props.initializeUserData.applicationInfo;
    let props = {
      tptEnabled
    };

    switch (mode) {
      case 'CREATE':
        component = <Create {...props} />
        break;
      case "EDIT":
        component = <Edit {...props} />;
        break;
      case "CLONE":
        component = <Clone {...props} />;
        break;
      case "TEMPLATE_CREATE":
        component = <TemplateCreate {...props} />;
        break;
      case "TEMPLATE_EDIT":
        component = <TemplateEdit {...props} />
    }
    return (
      component
    );
  }
}

export default SubmissionCrossover;
